// maxStep caps how far ahead of the active step the user can jump to — a
// step past it has no data yet, so it's shown locked and its click is a
// no-op. Omit (or pass steps.length) to leave every step open, e.g. a
// view-only/already-fully-created lead where every tab's data exists.
export default function Stepper({ steps, current, onGo, size = "form", maxStep = steps.length }) {
  return (
    <div className={"stepper stepper--" + size}>
      {steps.map((label, i) => {
        const n = i + 1;
        const done = n < current;
        const active = n === current;
        const locked = n > maxStep;
        return (
          <button
            type="button"
            key={label}
            className={"stepper__item" + (locked ? " stepper__item--locked" : "")}
            onClick={() => onGo(n)}
            disabled={locked}
            aria-disabled={locked}
          >
            {i > 0 && (
              <span className={"stepper__line" + (done || active ? " stepper__line--on" : "")} />
            )}
            <span
              className={
                "stepper__bubble" +
                (done ? " stepper__bubble--done" : active ? " stepper__bubble--active" : "")
              }
            >
              {done ? "✓" : n}
            </span>
            <span
              className={
                "stepper__label" +
                (done ? " stepper__label--done" : active ? " stepper__label--active" : "")
              }
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
